export default __webpack_public_path__ + "static/media/image_demo_imaging.f09663d5.png";